type EmailUserProps = {
    name: string;
    email: string;
    avatarUrl: string | null;
};

export default class EmailUser {
    name: string;

    email: string;

    avatarUrl: string | null;

    constructor({ name, email, avatarUrl }: EmailUserProps) {
        this.name = name;
        this.email = email;
        this.avatarUrl = avatarUrl;
    }

    get getInitials(): string {
        return `${this.name
            .split(" ")
            .map((n) => n[0])
            .join("")
            .slice(0, 2)}`;
    }
}
